import { LEVEL } from '_utils/level';

export const _LOAD_MODEL_ = 'Load:Puzzle';
export const _SAVE_MODEL_ = 'Save:Puzzle';
export const _DELETE_PUZZLE_ = 'Delete:Puzzle';

export const _PUZZLE_SELECTED_CELL_ = 'Selected:Puzzle';
export const _PUZZLE_ANSWER_OPTION_ = 'Answer:Puzzle';
export const _PUZZLE_QUESTION_OPTION_ = 'Question:Puzzle';
export const _PUZZLE_EDIT_QUESTION_OPTION_ = 'Question:Edit';
export const _PUZZLE_EDIT_QUESTION_UPDATED_ = 'Question:Edit:Updated';
export const _PUZZLE_GROUP_OPTION_ = 'Group:Puzzle';
export const _PUZZLE_PRE_GROUP_OPTION_ = 'PreGroup:Puzzle';
export const _PUZZLE_UNGROUP_OPTION_ = 'Ungroup:Puzzle';
export const _PUZZLE_ARROW_OPTION_ = 'Arrow:Puzzle';
export const _PUZZLE_CLOSE_ALL_MODAL_ = 'Close:Puzzle';
export const _PUZZLE_SET_ANSWER_ = 'SetAnswer:Puzzle';
export const _PUZZLE_UNLINK_RELATED_QUESTIONS_ =
  'UnlinkRelatedQuestions:Puzzle';
export const _PUZZLE_SET_QUESTION_ = 'SetQuestion:Puzzle';
export const _PUZZLE_SET_CELL_ = 'SetCell:Puzzle';

export const STATUS_OPTIONS = [
  { slug: 'draft', labelKey: 'shared.puzzle.status.draft' },
  { slug: 'completed', labelKey: 'shared.puzzle.status.completed' },
];

export const STATUS = {
  COMPLETED: 'completed',
  DRAFT: 'draft',
};

export const isPuzzleStatusCompleted = status => status === STATUS.COMPLETED;

export const getPuzzleStatusLabelKey = status =>
  isPuzzleStatusCompleted(status)
    ? 'shared.puzzle.status.completed'
    : 'shared.puzzle.status.draft';

export const ANSWER = {
  id: null,
  answer: null,
};

export const QUESTION = {
  id: null,
  question: null,
  answer_id: null,
  size_id: null,
  level: LEVEL.MEDIUM,
  size: {
    size: 9,
    name: 'Pequeno',
    slug: 'pequeno',
  },
};

export const CELL_SIZE = 60;
export const CELL_HEIGHT = 100;
export const FONT_SIZE = 9;

export const ARROW = {
  id: null,
  name: null,
  slug: null,
};

export const CELL = {
  id: null,
  type: 'col',
  hide: false,
  text: null,
  active: false,
  positionx: 0,
  positiony: 0,
  updated: true,
  direction: { ...ARROW },
  settings: {
    bold: true,
    font_size: FONT_SIZE,
    background: '#FFF7CC',
  },
  question_id: null,
  answer: { ...ANSWER },
  height: CELL_HEIGHT,
  children: [],
  question: { ...QUESTION },
  isAnswer: false,
  isQuestion: false,
  parent_id: null,
  direction_id: null,
  fixed: false,
  arrow_position: { ...ARROW },
  arrow_direction: { ...ARROW },
  arrow_position_id: null,
  arrow_direction_id: null,
  related_questions: null,
};

export const RESETTABLE_CELL_FIELDS = {
  text: null,
  updated: true,
  question_id: null,
  direction_id: null,
  arrow_position_id: null,
  arrow_direction_id: null,
};

export const MODEL = {
  id: null,
  name: null,
  slug: null,
  type_id: 1,
  template_id: null,
  status: 'draft',
  rows: 10,
  columns: 10,
  level: LEVEL.MEDIUM,
  settings: {
    puzzleTypeStyle: 'square',
    puzzleTitleColor: '#bbb',
    prioritize_quality: true,
    useCurrentGameReference: true,
    puzzleFontSize: 9,
    bankAnswersCount: 3,
    bank: [],
  },
  created_at: new Date(),
  updated_at: new Date(),
  f_created_at: new Date().toLocaleDateString(),
  f_updated_at: new Date().toLocaleDateString(),
  table: [{ ...CELL }],
  prev_id: null,
  next_id: null,
};

export const SPLIT = [
  { value: 25, labelKey: 'puzzle.split.third' },
  { value: 50, labelKey: 'puzzle.split.half' },
  { value: 75, labelKey: 'puzzle.split.twoThird' },
  { value: 0, labelKey: 'puzzle.split.twoColumns' },
];

export const SPLIT_VALUE_THIRD = 25;
export const SPLIT_VALUE_HALF = 50;
export const SPLIT_VALUE_TWO_THIRD = 75;
export const SPLIT_VALUE_TWO_COLUMNS = 0;

export const EXAMPLE_GRID_FILE = [
  '..E.......',
  '..S.......',
  '..T.......',
  'CRUZADAS..',
  '..D.......',
  '..I...J...',
  '.MOLOTOV..',
  '......G...',
  '......O...',
  '..........',
];

export const createResettableCellFields = () => ({
  ...RESETTABLE_CELL_FIELDS,
  answer: { ...ANSWER },
  question: { ...QUESTION },
  direction: { ...ARROW },
  arrow_position: { ...ARROW },
  arrow_direction: { ...ARROW },
});

export const cellHasLinkedAnswer = cell => Boolean(cell?.answer?.id);

export const letterIsBound = cell =>
  Boolean(cell?.related_questions?.length) || cellHasLinkedAnswer(cell);
